import React from 'react'

import styled from 'styled-components/native'

import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

import AvailabilityCard from '../../../common/components/availabilityCard/AvailabilityCard'

const Container = styled.View(({ theme }) => ({
  backgroundColor: theme.colors.backgroundPrimary,
  borderRadius: theme.spacing['12px'],
  boxShadow: '0px 0px 9px rgba(0, 0, 0, 0.1)',
  padding: theme.spacing['16px'],
  marginBottom: '20px',
}))

const CapacityDashlet: React.FC = () => {
  return (
    <Container testID={tID('CapacityDashlet')}>
      <AvailabilityCard isMinified hideCalendarAvailability={true} />
    </Container>
  )
}

export default CapacityDashlet
